export default "__VITE_ASSET__2175a4b2__"